export default "__VITE_PUBLIC_ASSET__c1246cf2__"